import React, { useState, useEffect } from 'react';
import { ThreatsProgressBar } from '../progress-bar/ThreatsProgressBar';
import './widgetBox.scss';
import { OptionSelector } from '../../option-selector/OptionSelector';

type Props = {
  onSelectedRangeChange: (selectedRange: number) => void;
  accountsData: any;
  darkmode: any;
};

export const ThreatsBars: React.FC<Props> = (props: Props) => {
  const [selectedRange, setSelectedRange] = useState<number>(1);

  useEffect(() => {
    // Invoke the callback whenever selectedRange changes
    props.onSelectedRangeChange(selectedRange);
  }, [selectedRange, onselectionchange]);

  const handleDateRangeChange = (days: number) => {
    // Perform logic to fetch data for the selected date range
    // Update chartData.series and options accordingly
    setSelectedRange(days);
  };

  const nonSelected = 'flex md:w-[4rem] lg:w-[7rem] justify-center text-sm py-1 border-2';
  const selected = 'flex md:w-[4rem] lg:w-[7rem] options justify-center text-sm py-1 border-2 bg-green-500';

  let originalData;
  if (Array.isArray(props.accountsData?.threatsGroupedByKey)) {
    originalData = { ...props.accountsData?.threatsGroupedByKey[0] }
  } else {
    originalData = { ...props.accountsData?.threatsGroupedByKey }

  }


  const formatData = (obj: number) => {
    return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, value ?? 0]));
  };

  const formattedData = formatData(originalData);
  const sum = Object.values(formattedData).reduce((sum: any, item: any) => sum + item, 0)

  if (!props.accountsData?.threatsGroupedByKey || Object.keys(props.accountsData?.threatsGroupedByKey).length === 0) {
    return (
      <div className="container-fluid widget py-5">
        <div className="d-flex">
          <div className="col-lg-12 col-md-12">
            <div className="d-flex justify-content-center" style={{ padding: '5px', marginTop: '10px' }}>
              <button
                className={selectedRange === 1 ? selected : nonSelected}
                style={{ borderRadius: '16px 0px 0px 16px',borderColor:'#35b888' }}
                onClick={() => handleDateRangeChange(1)}
              >
                <strong>Today</strong>
              </button>
              <button style={{borderColor:'#35b888'}} className={selectedRange === 7 ? selected : nonSelected} onClick={() => handleDateRangeChange(7)}>
                <strong >Past 7 days</strong>
              </button>
              <button
                className={selectedRange === 30 ? selected : nonSelected}
                style={{ borderRadius: '0px 16px 16px 0px',borderColor:'#35b888' }}
                onClick={() => handleDateRangeChange(30)}
              >
                <strong >Past 30 days</strong>
              </button>
              {/* <button
                className={selectedRange === 60 ? selected : nonSelected} style={{ borderRadius: "0px 16px 16px 0px" }}
                onClick={() => handleDateRangeChange(60)}
              >
                Past 60 days
              </button> */}
            </div>
          </div>
        </div>
        <div className="md:contents lg:flex justify-content-around">
          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Applications Firewalled'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Device Firewalled'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Malware Sites Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Device Abnormality Found'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Unauthorised Access Refused'} count={0} value={0} />
          </div>
          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Application Installations Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Suspicious Data Leaks Found'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Device Vulnerability Found'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Command & Control Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Remote Access Blocked'} count={0} value={0} />
          </div>
          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Phishing Attempts Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Botnet Sites Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Spam Generators Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'Adware Sites Blocked'} count={0} value={0} />
            <ThreatsProgressBar darkmode={props.darkmode} maxvalue={100} label={'File Hosting Sites Blocked'} count={0} value={0} />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container-fluid widget py-5" style={{ borderRadius: '16px' }}>
        <div className="d-flex">
          <div className="col-lg-12 col-md-12">
            <div className="d-flex justify-content-center" style={{ padding: '5px', marginTop: '10px' }}>
              <button
                className={selectedRange === 1 ? selected : nonSelected}
               style={{ borderRadius: '16px 0px 0px 16px',borderColor:'#35b888'}}
                onClick={() => handleDateRangeChange(1)}
              >
                <strong >Today</strong>
              </button>
              <button className={selectedRange === 7 ? selected : nonSelected} 
               style={{borderColor:'#35b888' }}
                onClick={() => handleDateRangeChange(7)}>
                <strong >Past 7 days</strong>
              </button>
              <button
                className={selectedRange === 30 ? selected : nonSelected}
                style={{ borderRadius: '0px 16px 16px 0px',borderColor:'#35b888' }}
                onClick={() => handleDateRangeChange(30)}
              >
                <strong >Past 30 days</strong>
              </button>
              {/* <button
                className={selectedRange === 60 ? selected : nonSelected} style={{ borderRadius: "0px 16px 16px 0px" }}
                onClick={() => handleDateRangeChange(60)}
              >
                Past 60 days
              </button> */}
            </div>
          </div>
        </div>
        <div className="md:contents lg:flex justify-content-around">
          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Applications Firewalled'}
              count={(formattedData?.app_fw !== undefined
                ? formattedData?.app_fw
                : 0
              ).toLocaleString()}
              value={
                formattedData?.app_fw !== undefined
                  ? Number(((formattedData?.app_fw / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              darkmode={props.darkmode}
              maxvalue={100}
              label={'Device Firewalled'}
              count={(props.accountsData?.threatsGroupedByKey?.dev_fw !== undefined
                ? formattedData?.dev_fw
                : 0
              ).toLocaleString()}
              value={
                formattedData?.dev_fw !== undefined
                  ? Number(((formattedData?.dev_fw / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              darkmode={props.darkmode}
              maxvalue={100}
              label={'Malware Sites Blocked'}
              count={(formattedData?.mw_site !== undefined
                ? formattedData?.mw_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.mw_site !== undefined
                  ? Number(((formattedData?.mw_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              darkmode={props.darkmode}
              maxvalue={100}
              label={'Device Abnormality Found'}
              count={(formattedData?.dev_ab !== undefined
                ? formattedData?.dev_ab
                : 0
              ).toLocaleString()}
              value={
                formattedData?.dev_ab !== undefined
                  ? Number(((formattedData?.dev_ab / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              darkmode={props.darkmode}
              maxvalue={100}
              label={'Unauthorised Access Refused'}
              count={(formattedData?.unauth !== undefined
                ? formattedData?.unauth
                : 0
              ).toLocaleString()}
              value={
                formattedData?.unauth !== undefined
                  ? Number(((formattedData?.unauth / sum) * 100).toFixed(0))
                  : 0
              }
            />
          </div>

          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar
              darkmode={props.darkmode}
              maxvalue={100}
              label={'Application Installations Blocked'}
              count={(formattedData?.app_blk !== undefined
                ? formattedData?.app_blk
                : 0
              ).toLocaleString()}
              value={
                formattedData?.app_blk !== undefined
                  ? Number(((formattedData?.app_blk / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Suspicious Data Leaks Found'}
              count={(formattedData?.data_leak !== undefined
                ? formattedData?.data_leak
                : 0
              ).toLocaleString()}
              value={
                formattedData?.data_leak !== undefined
                  ? Number(((formattedData?.data_leak / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Device Vulnerability Found'}
              count={(formattedData?.dev_vuln !== undefined
                ? formattedData?.dev_vuln
                : 0
              ).toLocaleString()}
              value={
                formattedData?.dev_vuln !== undefined
                  ? Number(((formattedData?.dev_vuln / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Command & Control Blocked'}
              count={(formattedData?.c2_site !== undefined
                ? formattedData?.c2_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.c2_site !== undefined
                  ? Number(((formattedData?.c2_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Remote Access Blocked'}
              count={(formattedData?.ras_site !== undefined
                ? formattedData?.ras_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.ras_site !== undefined
                  ? Number(((formattedData?.ras_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
          </div>

          <div className="flex flex-col gap-1 p-2" style={{ marginTop: '5px' }}>
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Phishing Attempts Blocked'}
              count={(formattedData?.ph_site !== undefined
                ? formattedData?.ph_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.ph_site !== undefined
                  ? Number(((formattedData?.ph_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Botnet Sites Blocked'}
              count={(formattedData?.bot_site !== undefined
                ? formattedData?.bot_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.bot_site !== undefined
                  ? Number(((formattedData?.bot_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Spam Generators Blocked'}
              count={(formattedData?.sp_site !== undefined
                ? formattedData?.sp_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.sp_site !== undefined
                  ? Number(((formattedData?.sp_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'Adware Sites Blocked'}
              count={(formattedData?.ad_site !== undefined
                ? formattedData?.ad_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.ad_site !== undefined
                  ? Number(((formattedData?.ad_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
            <ThreatsProgressBar
              maxvalue={100}
              darkmode={props.darkmode}
              label={'File Hosting Sites Blocked'}
              count={(formattedData?.fas_site !== undefined
                ? formattedData?.fas_site
                : 0
              ).toLocaleString()}
              value={
                formattedData?.fas_site !== undefined
                  ? Number(((formattedData?.fas_site / sum) * 100).toFixed(0))
                  : 0
              }
            />
          </div>
        </div>
      </div>
    );
  }
};
